// News cluster taxonomy — mirrors Backend_Web/api/news_classifier.py.
// Keep keys/labels in sync with the backend CATEGORY_META.
// Icons are monochrome Heroicon (outline) components, not emoji.

import {
  ChartBarIcon, BriefcaseIcon, PresentationChartLineIcon, ScaleIcon,
  QuestionMarkCircleIcon, UserCircleIcon, RocketLaunchIcon, GlobeAltIcon,
  PresentationChartBarIcon, ExclamationTriangleIcon, Squares2X2Icon,
  CheckBadgeIcon, ChatBubbleLeftRightIcon,
} from '@heroicons/react/24/outline';

export const CLUSTERS = {
  earnings:    { Icon: ChartBarIcon,             label: 'Earnings & Results',        color: 'bg-emerald-100 text-emerald-800 dark:bg-emerald-900/30 dark:text-emerald-300' },
  deals:       { Icon: BriefcaseIcon,            label: 'Deals & Corporate Actions', color: 'bg-indigo-100 text-indigo-800 dark:bg-indigo-900/30 dark:text-indigo-300' },
  analyst:     { Icon: PresentationChartLineIcon, label: 'Analyst Ratings',          color: 'bg-sky-100 text-sky-800 dark:bg-sky-900/30 dark:text-sky-300' },
  regulatory:  { Icon: ScaleIcon,               label: 'Regulatory & Legal',         color: 'bg-amber-100 text-amber-800 dark:bg-amber-900/30 dark:text-amber-300' },
  speculation: { Icon: QuestionMarkCircleIcon,  label: 'Speculation & Rumors',       color: 'bg-purple-100 text-purple-800 dark:bg-purple-900/30 dark:text-purple-300' },
  leadership:  { Icon: UserCircleIcon,          label: 'Leadership & Insiders',      color: 'bg-cyan-100 text-cyan-800 dark:bg-cyan-900/30 dark:text-cyan-300' },
  product:     { Icon: RocketLaunchIcon,        label: 'Products & Partnerships',    color: 'bg-pink-100 text-pink-800 dark:bg-pink-900/30 dark:text-pink-300' },
  macro:       { Icon: GlobeAltIcon,            label: 'Macro & Economy',            color: 'bg-blue-100 text-blue-800 dark:bg-blue-900/30 dark:text-blue-300' },
  market:      { Icon: PresentationChartBarIcon, label: 'Market Moves',              color: 'bg-teal-100 text-teal-800 dark:bg-teal-900/30 dark:text-teal-300' },
  risk:        { Icon: ExclamationTriangleIcon, label: 'Risk & Controversy',         color: 'bg-rose-100 text-rose-800 dark:bg-rose-900/30 dark:text-rose-300' },
  other:       { Icon: Squares2X2Icon,          label: 'Other',                      color: 'bg-gray-100 text-gray-700 dark:bg-gray-800 dark:text-gray-300' },
};

// Ordered list for filter dropdowns / tab rows.
export const CLUSTER_ORDER = [
  'earnings', 'deals', 'analyst', 'regulatory', 'speculation',
  'leadership', 'product', 'macro', 'market', 'risk', 'other',
];

export const getCluster = (key) => CLUSTERS[key] || CLUSTERS.other;

// Reverse lookup by label (blogs store the human label, not the key).
export const getClusterByLabel = (label) =>
  Object.values(CLUSTERS).find(c => c.label === label) || null;

// Credibility tier badge styling + monochrome icon.
export const CREDIBILITY = {
  genuine:     { Icon: CheckBadgeIcon,          label: 'Genuine',     color: 'bg-green-100 text-green-800 dark:bg-green-900/30 dark:text-green-300' },
  speculation: { Icon: QuestionMarkCircleIcon,  label: 'Speculation', color: 'bg-amber-100 text-amber-800 dark:bg-amber-900/30 dark:text-amber-300' },
  opinion:     { Icon: ChatBubbleLeftRightIcon, label: 'Opinion',     color: 'bg-slate-100 text-slate-700 dark:bg-slate-800 dark:text-slate-300' },
};

export const getCredibility = (tier) => CREDIBILITY[tier] || CREDIBILITY.genuine;
